export default __webpack_public_path__ + "static/media/manage_communication_icon.86eff8bb.svg";